import { useAdminUpdate } from '@reapitform/hooks'
import { AdminFormPayload, AdminFormResponse } from '../types'

/** Updates a form definition (`PUT /api/forms/{formReferenceID}`). */
export const useUpdateAdminForm = (formReferenceID: string) =>
  useAdminUpdate<AdminFormPayload, AdminFormResponse>({
    path: `/api/forms/${formReferenceID}`,
    method: 'PUT',
    errorMessage: 'Failed to update the form',
  })
